import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "../../ui/tooltip";
import "../../assets/css/RiskExplorer/style.css";

// @ts-ignore
import Header from "../../components/Header";
// @ts-ignore
import RightAside from "../../components/RightAside";
// @ts-ignore
import UserService from "../../services/UserService";

import { RiskAppetitePage } from "./pages/RiskAppetitePage";

const queryClient = new QueryClient();

function RiskAppetiteManagementInner() {
  useEffect(() => {
    document.body.classList.add("risk-explorer-active");
    return () => document.body.classList.remove("risk-explorer-active");
  }, []);

  const token = UserService.getToken();

  return (
    <div className="risk-explorer-theme">
      <Header
        token={token}
        isMarketplacePage={false}
        notificationsCount={0}
        refreshNotifications={() => {}}
        setIndustry={() => {}}
        setCompany={() => {}}
        leftNode={null}
        productLabel="Risk Appetite Management"
        fixed={true}
      />
      <RiskAppetitePage />
      <RightAside showChildrenWhenNoPanel={false}>{null}</RightAside>
    </div>
  );
}

export default function RiskAppetiteManagement() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <RiskAppetiteManagementInner />
      </TooltipProvider>
    </QueryClientProvider>
  );
}
